import { CategoryDetails, SubCategory } from "@/types";
import { categoryDetails as categoryA } from "./1";
import { categoryDetails as categoryB } from "./2";

export const serviceCategories: CategoryDetails[] = [categoryA, categoryB].sort(
  (a, b) => (a.order ?? a.id) - (b.order ?? b.id),
);

const contentObject: Record<number, CategoryDetails> = Object.fromEntries(
  serviceCategories.map((category) => [category.id, category]),
);

export const getServiceCategories = () => serviceCategories;

export const getServiceCategoryBySlug = (categorySlug: string) =>
  serviceCategories.find((category) => category.slug === categorySlug);

export const getServiceSubCategories = (): SubCategory[] =>
  serviceCategories.flatMap((category) => category.subCategories || []);

export const getServiceSubCategoryBySlug = (
  categorySlug: string,
  serviceSlug: string,
) =>
  getServiceCategoryBySlug(categorySlug)?.subCategories?.find(
    (service) => service.slug === serviceSlug,
  );

export default contentObject;
